module.exports = __webpack_public_path__ + "img/project-14.31cb91f4.png";